module.exports = __webpack_public_path__ + "static/media/ticket-alert.7c7d40d1.svg";